import { styled } from "@mui/material/styles";
const PendingApprovalMain = styled("div")(({ theme }) => ({
  maxWidth: "500px",
  margin: "auto",
  textAlign: "center",
  paddingTop: "100px",
  paddingBottom: "100px",
  "& button": {
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  [theme.breakpoints.down("sm")]: {
    paddingBottom: "80px",
    paddingTop: "50px",
    maxWidth: "100%",
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    paddingBottom: "80px",
    paddingTop: "50px",
    maxWidth: "100%",
    width: "100%",
    "& button": {
      width: "100%",
    },
  },
}));

const PendingImg = styled("div")(({ theme }) => ({
  textAlign: "center",
  marginBottom: "10px",
  "& img": {
    maxWidth: "100%",
    height: "auto",
  },
}));
const PendingText = styled("div")(({ theme }) => ({
  textAlign: "center",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "28px",
    lineHeight: "44px",
    textAlign: "center",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    marginBottom: "10px",
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "30px",
    textAlign: "center",
    color: "rgba(11, 11, 11, 0.75)",
    fontFamily: theme.typography.fontFamily,
  },
  [theme.breakpoints.down("md")]: {
    "& h6": {
      fontSize: "20px",
      marginBottom: "8px",
    },
    "& p": {
      fontSize: "16px",
    },
  },
}));

export { PendingApprovalMain, PendingImg, PendingText };
